// actions/orderActions.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const createOrder = createAsyncThunk(
  "order/createOrder",
  async (orderData, thunkAPI) => {
    try {
      const baseURL = process.env.REACT_APP_BASE_URL;

      const response = await axios.post(
        `${baseURL}/products/create-order`,
        orderData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Something went wrong"
      );
    }
  }
);

// slices/orderSlice.js
import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoading: false,
  error: null,
  errors: null, // for validation errors
  success: false,
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    clearOrderState: (state) => {
      state.isLoading = false;
      state.error = null;
      state.errors = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errors = null;
        state.success = false;
      })
      .addCase(createOrder.fulfilled, (state) => {
        state.isLoading = false;
        state.success = true;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.isLoading = false;
        state.success = false;
        state.error = action.payload?.message || 'حدث خطأ غير متوقع';
        state.errors = action.payload?.errors || null;
      });
  },
});

export const { clearOrderState } = orderSlice.actions;
export default orderSlice.reducer;